<template>
	<header>
		<h3>{{menuName}}</h3>
		<el-button @click.native="logOut" class="btn-logout">退出</el-button>
	</header>
</template>

<script>
	import {
		logout
	} from '@/api/login'
	import Cookies from 'js-cookie'
	export default {
		data() {
			return {}
		},
		computed: {
			menuName() {
				return this.$store.state.tab.menuName;
			}
		},
		methods: {
			//退出登陆
			logOut() {
				let _this = this;
				_this.$throttle.canDoFunction({
				  key: "logOut",
				  time: 3000,
				  success: () => {
					  logout(Cookies.get('token')).then(res => {
					  	Cookies.remove('token');
					  	localStorage.removeItem('menuName');
					  	_this.$router.push({name: 'login'});
					  })
				    
				  }
				});
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	header {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: space-between;
	}

	.btn-logout {
		width: 52px !important;
		height: 26px;
		border: 1px solid #A5BFBC;
		border-radius: 13px;
		color: #425D58;
		text-align: center;
		font-size: 14px;
		padding: 0;
	}
</style>
